import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22f5562e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_TheSymbolButton = _resolveComponent("TheSymbolButton")
  const _component_SymbolList = _resolveComponent("SymbolList")
  const _component_Scroller = _resolveComponent("Scroller")
  const _component_FullScreen = _resolveComponent("FullScreen")

  return (_openBlock(), _createBlock(_component_FullScreen, { class: "px-16 df-col" }, {
    default: _withId(() => [
      _createVNode(_component_PageHeader, null, {
        title: _withId(() => [
          _createVNode(_component_t, { path: "editmonitoring_2" })
        ]),
        _: 1
      }),
      _createVNode(_component_Scroller, {
        "css-only": "",
        class: "flex-1"
      }, {
        default: _withId(() => [
          _createVNode(_component_SymbolList, {
            onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save')))
          }, {
            default: _withId(({symbol}) => [
              _createVNode(_component_TheSymbolButton, { symbol: symbol }, null, 8, ["symbol"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})